export default __webpack_public_path__ + "static/media/enghien05.8d256b69.jpg";